import { render, staticRenderFns } from "./GestioneUtente.vue?vue&type=template&id=73cca1c2&scoped=true&"
import script from "./GestioneUtente.vue?vue&type=script&lang=js&"
export * from "./GestioneUtente.vue?vue&type=script&lang=js&"
import style0 from "./GestioneUtente.vue?vue&type=style&index=0&id=73cca1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cca1c2",
  null
  
)

export default component.exports